import { render, staticRenderFns } from "./AddArticle.vue?vue&type=template&id=184c4020&scoped=true"
import script from "./AddArticle.vue?vue&type=script&lang=js"
export * from "./AddArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184c4020",
  null
  
)

export default component.exports